// export const BASE_URL = "http://localhost:8090/MadaniSS/";
// export const BASE_URL = "http://localhost:8090/MadaniSS_JOINAPI/";
// export const BASE_URL = "http://madani-tech.com/MadaniSS_API/";
// export const BASE_URL = "http://madani-tech.com/MadaniSS_API/";
export const BASE_URL = "https://yyssyekhalijaber.madani-tech.com/mss/";
// export const BASE_URL = "https://mss.imadani.id/";
export const API_URL = BASE_URL + "index.php/api/";
export const PATH_FOLDER = BASE_URL + "assets/upload/";

export const IS_MULTIPLE_SCHOOL = false;

export const YAYASAN = "265";
export const KODE_SEKOLAH = "1488";
export const NAMA_YAYASAN = "Yayasan Pendidikan Mahir Dengan Al-Qur'an"; // Title halaman login dan home
export const SUB_NAMA_YAYASAN = ""; // Subtitle halaman login dan home // Kosongkan jika tidak digunakan

export const URL_ONESIGNAL = "https://onesignal.com/api/v1/notifications";
export const APP_ID_ONESIGNAL = "f74b990a-786d-40de-843e-f3b80f4a1b39";
export const AUTHORIZATION_ONESIGNAL = "Basic Mzk1OTkyYzMtN2M0MS00YzM5LWE1Y2UtMDYwOTI4NjUxZmQy";


// WEBPACK FOOTER //
// ./src/providers/config.ts